import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Appeaz } from '../../../app/tools/models/appeaz';
import { Asset } from '../../../app/tools/models/asset';
import { AppeazService } from '../../../app/tools/services/appeaz.service';
import { PaletteService } from '../../../app/tools/services/palette.service';

@Component({
  selector: 'eazly-palette',
  templateUrl: './palette.component.html',
  styleUrls: ['./palette.component.scss']
})
export class PaletteComponent implements OnInit {
  public static advancedAssets = [];

  @Input()
  myappeaz: Appeaz;
  assets: Asset[] = [];

  constructor(
    private readonly appeazService: AppeazService,
    private readonly paletteService: PaletteService,
  ) { }

  ngOnInit(): void {
    this.appeazService.getAppeazJWT(this.getappeaz().id, this.getappeaz().role).then(
      (dataJwt) => {
        this.paletteService.getAssets(this.getappeaz().url, dataJwt).subscribe(
          (assets) => {
            assets.forEach(element => {
              this.assets.push(element);
            });
          }
        );
        this.paletteService.getCustomPalette(this.getappeaz().url).subscribe(
          (customAssets) => {
            PaletteComponent.advancedAssets = customAssets;
            customAssets.forEach(element => {
              this.assets.push(element);
            });
          }
        )
      },
    );
  }

  private getappeaz(): Appeaz {
    return this.myappeaz;
  }

   startDrag(event: Event): void {
    this.paletteService.dragStartedEventEmitter.emit(event)
  }

   endDrag(event: Event): void {
    this.paletteService.dragEndedEventEmitter.emit(event)
  }

  public static getAdvancedPalette() {
    return this.advancedAssets;
  }
}
